// Regex patterns for URI validation
const ILLEGAL_CHARS_REGEX = /[^a-z0-9:/?#[\]@!$&'()*+,;=.\-_~%]/i
const INCOMPLETE_HEX_ESCAPE_REGEX = /%[^0-9a-f]/i
const INCOMPLETE_HEX_ESCAPE_END_REGEX = /%[0-9a-f](:?[^0-9a-f]|$)/i
const PATH_START_SLASH_REGEX = /^\//
const PATH_START_DOUBLE_SLASH_REGEX = /^\/\//
const SCHEME_FORMAT_REGEX = /^[a-z][a-z0-9+\-.]*$/
const URI_SPLIT_REGEX =
  /(?:([^:/?#]+):)?(?:\/\/([^/?#]*))?([^?#]*)(?:\?([^#]*))?(?:#(.*))?/

export function isUri(value: string) {
  // based on https://github.com/ogt/valid-url

  // check for illegal characters
  if (ILLEGAL_CHARS_REGEX.test(value)) {
    return false
  }

  // check for hex escapes that aren't complete
  if (INCOMPLETE_HEX_ESCAPE_REGEX.test(value)) {
    return false
  }
  if (INCOMPLETE_HEX_ESCAPE_END_REGEX.test(value)) {
    return false
  }

  // from RFC 3986
  const splitted = splitUri(value)
  const scheme = splitted.at(1)
  const authority = splitted.at(2)
  const path = splitted.at(3)
  const query = splitted.at(4)
  const fragment = splitted.at(5)

  // scheme and path are required, though the path can be empty
  if (!(scheme?.length && path !== undefined && path.length >= 0)) {
    return false
  }

  // if authority is present, the path must be empty or begin with a /
  if (authority?.length) {
    if (!(path.length === 0 || PATH_START_SLASH_REGEX.test(path))) {
      return false
    }
  } else if (PATH_START_DOUBLE_SLASH_REGEX.test(path)) {
    // if authority is not present, the path must not start with //
    return false
  }

  // scheme must begin with a letter, then consist of letters, digits, +, ., or -
  if (!SCHEME_FORMAT_REGEX.test(scheme.toLowerCase())) {
    return false
  }

  let out = ""
  // re-assemble the URL per section 5.3 in RFC 3986
  out += `${scheme}:`
  if (authority?.length) {
    out += `//${authority}`
  }

  out += path

  if (query?.length) {
    out += `?${query}`
  }
  if (fragment?.length) {
    out += `#${fragment}`
  }

  return out
}

function splitUri(value: string) {
  const match = value.match(URI_SPLIT_REGEX)
  if (!match) {
    throw new Error("Invalid URI")
  }
  return match
}
